export default "__VITE_ASSET__CMEjyaL9__"